export default __webpack_public_path__ + "static/media/funny, silly, cheerful, friendly, young.a7d36e3e.jpg";